export class Level {
    constructor(
      public hash?: string,
      public level?: string
    ) { }

    clone() {
      return new Level(
        this.hash,
        this.level
      );
    }
  }
